import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { ChatHTMLElement } from './chat.styled';

const TypingAnimation = ({ text, loop = false }: { text: string; loop?: boolean }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const words = text.split(' ');
  const speed = 20;

  useEffect(() => {
    if (index < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => (prev ? `${prev} ${words[index]}` : words[index]));
        setIndex((prev) => prev + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else if (loop) {
      const loopTimeout = setTimeout(() => {
        setDisplayedText('');
        setIndex(0);
      }, speed);
      return () => clearTimeout(loopTimeout);
    }
  }, [index, words, speed, loop]);

  const sanitizedHTML = DOMPurify.sanitize(displayedText);
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHTML, 'text/html');
  const links = doc.querySelectorAll('a');
  links.forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
  const modifiedHTML = doc.body.innerHTML;

  return <ChatHTMLElement dangerouslySetInnerHTML={{ __html: modifiedHTML }} />;
};

export default TypingAnimation;
